import { render, staticRenderFns } from "./next_detail.vue?vue&type=template&id=a5ce6462&scoped=true&"
import script from "./next_detail.vue?vue&type=script&lang=js&"
export * from "./next_detail.vue?vue&type=script&lang=js&"
import style0 from "./next_detail.vue?vue&type=style&index=0&id=a5ce6462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ce6462",
  null
  
)

export default component.exports